import FormFeedbackBanner from "../../components/forms/FormFeedbackBanner";
import { responsiveImageProps } from "../../utils/responsiveImages";
import React, { FormEvent, useEffect, useState } from "react";
import { appConfig } from "../../config/appConfig";
import { useLocalization } from "../../localization";
import "./TemporaryLaunchPage.css";

type TemporaryLaunchPageProps = {
  onAccessGranted: () => void;
};

const TemporaryLaunchPage = ({ onAccessGranted }: TemporaryLaunchPageProps) => {
  const { t } = useLocalization();
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  useEffect(() => {
    const previousTitle = document.title;
    document.title = t("RAUXA | Under maintenance");

    return () => {
      document.title = previousTitle;
    };
  }, [t]);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (password === appConfig.temporaryLaunchGate.password) {
      setErrorMessage(null);
      onAccessGranted();
      return;
    }

    setErrorMessage(t("That access code did not work."));
  };

  return (
    <main className="temporary-launch-page" id="main-content" tabIndex={-1}>
      <div className="temporary-launch-glow temporary-launch-glow-pink" />
      <div className="temporary-launch-glow temporary-launch-glow-blue" />
      <section
        className="temporary-launch-content"
        aria-labelledby="temporaryLaunchTitle"
      >
        <img
          className="temporary-launch-logo"
          {...responsiveImageProps("/assets/landing/rauxa-logo.png", "112px")}
          alt=""
          loading="eager"
        />
        <p className="temporary-launch-kicker">{t("RAUXA maintenance")}</p>
        <h1 id="temporaryLaunchTitle">{t("RAUXA is under maintenance.")}</h1>
        <p className="temporary-launch-message">
          {t(
            "We're making a few updates to improve race registration and payments. Please check back shortly."
          )}
        </p>

        <form className="temporary-launch-form" onSubmit={handleSubmit}>
          <label className="temporary-launch-label" htmlFor="temporaryLaunchPassword">
            {t("Team access code")}
          </label>
          <div className="temporary-launch-password-row">
            <input
              id="temporaryLaunchPassword"
              className="temporary-launch-password-input"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(event) => {
                setPassword(event.target.value);
                setErrorMessage(null);
              }}
            />
            <button className="temporary-launch-submit" type="submit">
              {t("Continue")}
            </button>
          </div>
          {errorMessage ? (
            <FormFeedbackBanner tone="error" messageKey={errorMessage}>
              {errorMessage}
            </FormFeedbackBanner>
          ) : null}
        </form>
      </section>
    </main>
  );
};

export default TemporaryLaunchPage;
